module.exports = __webpack_public_path__ + "img/xls.23c16b36.svg";